enum ExactOnlinePaymentCondition {
  Days14 = 'Days14',
  Days30 = 'Days30',
  TwoPercentDiscountIn8Days = 'TwoPercentDiscountIn8Days',
}

export default ExactOnlinePaymentCondition;
